export default "__VITE_ASSET__68339c98__"